import React from 'react';
import { Typography, Box } from '@mui/material';
import NoImage from '@assets/images/not-found.png';
import './styles.scss';

const NoDataFound = ({title = 'No Orders Yet – Start Adding One!', height='65vh'}: any) => (
    <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: {height}, overflow: 'hidden'}}>
        <Box sx={{textAlign: 'center'}}>
            <img src={NoImage} className='imgNotFound' alt="" />
            <Typography color='primary' sx={{textAlign: "center", fontWeight: "500"}}>{title}</Typography>
        </Box>
    </Box>
)

export default NoDataFound;
